/* unplugin-vue-components disabled */import script from "./CashierManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CashierManager.vue?vue&type=script&setup=true&lang=js"

import "./CashierManager.vue?vue&type=style&index=0&id=f712061c&lang=scss"

const __exports__ = script;

export default __exports__